import { getVariantQrTag } from './exchangeVariant';

/**
 * Permanent-URL assembly — ONE home (extraction signed off at plan 3 Step 8;
 * the epic's tech-debt list had `buildPermanentUrl` queued, and the ICS link
 * would have been the FOURTH hand-rolled copy of the same string).
 *
 * Every permanent link the app hands out — the QR, TEXT's texted link, the
 * host's self-text, THREAD's calendar reminder — is `{origin}/u/{id}` plus the
 * active variant's QR tag, so a scan or a return mirrors the host's variant for
 * that visit. Assembling it in one place is what keeps that guarantee true:
 * a site that forgets the tag silently drops returners into the default
 * variant, which is a data problem (the analytics stamp goes with it), not a
 * cosmetic one.
 *
 * The tag is '' for whatever variant is currently main's default, so production
 * URLs stay byte-identical (the 58-byte QR ceiling — CLAUDE-PROJECT § QR).
 */
export const buildPermanentUrl = (profileUserId) =>
  `${window.location.origin}/u/${profileUserId}${getVariantQrTag()}`;

/**
 * The host's profileUserId as seen from the ANON side: the prefetch payload
 * when the page was server-rendered, else the /u/:id path the scan landed on.
 */
export const getHostProfileUserId = () =>
  window.__EXCHANGE_DATA__?.profileUserId || window.location.pathname.split('/u/')[1] || null;
